var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-group pb-2"},[_c('div',{staticClass:"form-check"},[_c('input',{staticClass:"form-check-input",attrs:{"type":"checkbox","id":_vm.inputId}}),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.inputId}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.field.attrs.label)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }